// @flow

import React, { type Node } from 'react';
import Tippy from '@tippy.js/react';
import { fontWeight } from '../constants';
import { injectGlobal } from 'styled-components';

type Props = {
  content: string,
  children: Node,
  placement: 'top' | 'bottom' | 'left' | 'right',
  className?: string,
};

class Tooltip extends React.Component<Props> {
  static defaultProps = {
    allowHTML: false,
    appendTo: 'parent',
    animation: 'fade',
    arrow: true,
    duration: 200,
    hideOnClick: true,
    placement: 'bottom',
    theme: 'dark',
    trigger: 'mouseenter focus',
  };

  render() {
    const { className, children, ...otherProps } = this.props;
    return (
      <Tippy
        popperOptions={{
          positionFixed: true,
        }}
        {...otherProps}
      >
        {/* Without tabIndex -1 the user would need to double-tab to focus the inner elements */}
        <span tabIndex="-1" className={className}>
          {children}
        </span>
      </Tippy>
    );
  }
}

injectGlobal`
  .tippy-content {
    font-size: 12px;
    ${fontWeight('heavy')}
  }
`;

export default Tooltip;
